import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeDrawer } from "../store/navSlice";

import "./Drawer.scss";
import { ReactComponent as IconCaret } from "../assets/images/caret.svg";

const Drawer = ({ children }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const open = useSelector((state) => state.nav.drawerOpen);

  return (
    <div className={`app-drawer noselect ${open ? "open" : ""}`}>
      <div className="drawer-handle">
        <div className="handle-line"></div>
        <button
          className="btn btn-circle handle-btn"
          onClick={() => dispatch(closeDrawer())}
          title={t("hide")}
        >
          <IconCaret className="icon" />
        </button>
      </div>
      <div className="drawer-content">
        {children}
      </div>
    </div>
  );
};

export default Drawer;
